import { type UseQueryResult, useQuery } from '@tanstack/react-query';
import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGINS_KEY } from '@/keys';
import type { ProductionDeclarationCommodityOrigin } from '@/types/core/purchase-order/production-declaration-commodity-origin';

async function getProductionDeclarationMaterialCommodityOrigins(
  productionDeclarationId: string,
  materialId: string,
  options?: { token?: string },
): Promise<ProductionDeclarationCommodityOrigin[]> {
  const response = await api.get<ProductionDeclarationCommodityOrigin[]>(
    `/production-declarations/${productionDeclarationId}/materials/${materialId}/commodity-origins`,
    {
      params: options?.token ? { token: options.token } : undefined,
    },
  );

  return response.data;
}

export function useGetProductionDeclarationMaterialCommodityOrigins(
  productionDeclarationId: string,
  materialId: string,
  token: string | undefined,
): UseQueryResult<ProductionDeclarationCommodityOrigin[], Error> {
  return useQuery({
    queryKey: [
      ...GET_PRODUCTION_DECLARATION_MATERIAL_COMMODITY_ORIGINS_KEY,
      productionDeclarationId,
      materialId,
      token ?? '',
    ],
    queryFn: async () =>
      await getProductionDeclarationMaterialCommodityOrigins(
        productionDeclarationId,
        materialId,
        {
          token,
        },
      ),
    enabled: Boolean(productionDeclarationId && materialId),
  });
}
